import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { getBenef, setBenef } from "../../../Store/storages/BeneficiarioStorage";
import LoadingApp from "../../../components/LoadingApp";
import ModalAction from "../../../components/ModalAction";
import useFocus from "../../../utils/hooks/useFocus";
import CameraAcess from "./CameraAcess";
import './styles.css';
import { sxButton } from "./sxProps";
import PageTitle from "../../../components/Accessibility/PageTitle";

export default function BiometriaFacial() {

  const [allowCamera, setAllowCamera] = useState(false);
  const [alredyRegistered, setAlredyRegistered] = useState(false);
  const [loadingApp, setLoadingApp] = useState(true);
  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string;
    title: string; subTitle?: string; handleOutlinedButton?: () => void; handleContainedButton?: () => void; icon?: "error" | "success" | "warning"
  }>(null);
  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const focusRef = useFocus();
  const accessibility = useAccessibility();

  useEffect(() => {
    getPermissionsBiometric();
  }, [])

  var getPermissionsBiometric = async () => {
    setAlredyRegistered(getBenef()?.indBioFacial === 'S')
    setLoadingApp(false)
  }


  const registerBiometrics = async () => {
    if (!allowCamera) {
      openModalAction();
    }
  }

  const openModalAction = () => {
    setModalAction({
      title: 'Permissão para acessar a câmera',
      subTitle: `Precisamos acessar a sua câmera para prosseguir`,
      textOutlinedButton: 'NÃO PERMITIR',
      textContainedButton: 'PERMITIR',
      handleContainedButton: allowButton,
      handleOutlinedButton: notAllowButton,
      handleShowModal: () => setModalAction(null)
    })
  }

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error('Erro ao acessar a câmera: ', error);
    }
  };

  const allowButton = async () => {
    await startCamera();
    setModalAction(null);
    setAllowCamera(true);
  }

  const notAllowButton = () => {
    setModalAction(null);
  }

  const handleValidation = () => {
    setAllowCamera(false);
    let benef = getBenef();
    if (benef?.indBioFacial !== undefined) {
      benef.indBioFacial = 'S';
      setBenef(benef)
    }
    navigate('/home');
  }

  const handleContinue = () => {
    setAllowCamera(false);
    navigate('/home')
  }

  return (
    <div className="facial-biometrics-holder">
      <LoadingApp showLoading={loadingApp} />
      {allowCamera && <CameraAcess handleValidation={handleValidation} handleContinue={handleContinue} />}
      <PageTitle text="Biometria Facial" />
      <p className="facial-biometrics-intro" style={accessibility.textStyleAccessibility}>Tenha mais segurança e agilidade no seu atendimento.</p>
      <div className="facial-biometrics-description-holder" style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
        <p className="facial-biometrics-description" style={accessibility.textStyleAccessibility}>O cadastro da biometria facial é único. Caso precise atualizar a sua foto, envie um e-mail para <strong style={accessibility.contrastColorAccessibility} >aplicativo@unimedcampinas.com.br</strong></p>
      </div>
      <h2 className="facial-biometrics-register" style={accessibility.textStyleAccessibility}>Cadastro de Biometria Facial</h2>
      <div className="facial-biometrics-button">
        {alredyRegistered ?
          <p className="facial-biometrics-intro" style={accessibility.textStyleAccessibility}>Você já possui Biometria Facial cadastrada.</p>
          :
          <Button
            variant="contained"
            size="large"
            onClick={registerBiometrics}
            sx={sxButton}
            style={accessibility.textStyleAccessibility}
            fullWidth>
            CADASTRAR
          </Button>}
      </div>
      <ModalAction
        showModal={!!modalAction}
        handleShowModal={modalAction?.handleShowModal}
        icon={modalAction?.icon}
        textOutlinedButton={modalAction?.textOutlinedButton || ''}
        textContainedButton={modalAction?.textContainedButton || ''}
        title={modalAction?.title || ''}
        subTitle={modalAction?.subTitle || ''}
        handleOutlinedButton={modalAction?.handleOutlinedButton}
        handleContainedButton={modalAction?.handleContainedButton}
      />
    </div>
  )
}
